<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>
			<div class="c-portlet__header demographicHeader">
				<div class="o-stack__cell">
					<h5 class="card-title">Social Demographics</h5>
					<span *ngIf="hasData" class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV($event)"
							target="_blank"
							*ngIf="downloadconfig && downloadconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
			</div>
			<div class="legend-area">
				Metric:
				<select id="socialLegendSelected" (change)="processGraphdata($event.target.value)">
					<option value="impressions">Impressions</option>
					<option value="clicks">Clicks</option>
					<option value="engagements">Engagements</option>
				</select>
			</div>
			<div [hidden]="!hasData" #chartcontainer class="donut-div"></div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="devices-data-container height-100p" *ngIf="hasData">
				<div class="c-portlet__header socialTable">
					<div class="o-stack__cell">
						<h5>Social Demographic Breakdown</h5>
					</div>
				</div>
				<div class="legend-area socialTableLegend">
					Metric:
					<select id="legendSelected" (change)="processTabledata($event.target.value)">
						<option value="impressions">Impressions</option>
						<option value="clicks">Clicks</option>
						<option value="click_rate">Click Rate</option>
						<option value="engagements">Engagements</option>
					</select>
				</div>
				<div class="device-breakdown-data">
					<div>
						<div class="devices-header-row">
							<div class="width-33p device-data table-header">Age</div>
							<div class="width-33p device-data table-header" [ngClass]="{ 'secondary-color': true }">Male</div>
							<div class="width-33p device-data table-header" [ngClass]="{ 'primary-color': true }">Female</div>
							<div class="width-33p device-data table-header" [ngClass]="{ 'tertiary-color': true }">Unknown</div>
						</div>
						<div class="devices-body">
							<div *ngIf="!isClickRate">
								<div *ngFor="let data of tableData; let index = index">
									<div class="width-33p device-data font-600p">{{ data.age_group }}</div>
									<div class="width-33p device-data" [ngClass]="{ 'secondary-color': true }">
										<div *ngIf="data.male_data">{{ data.male_data | formatNumber }}</div>
										<div *ngIf="!data.male_data">--</div>
									</div>
									<div class="width-33p device-data" [ngClass]="{ 'primary-color': true }">
										<div *ngIf="data.female_data">{{ data.female_data | formatNumber }}</div>
										<div *ngIf="!data.female_data">--</div>
									</div>
									<div class="width-33p device-data" [ngClass]="{ 'tertiary-color': true }">
										<div *ngIf="data.unknown_data">{{ data.unknown_data | formatNumber }}</div>
										<div *ngIf="!data.unknown_data">--</div>
									</div>
								</div>
							</div>
							<div *ngIf="isClickRate">
								<div *ngFor="let data of tableData; let index = index">
									<div class="width-33p device-data font-600p">{{ data.age_group }}</div>
									<div class="width-33p device-data" [ngClass]="{ 'secondary-color': true }">
										<div *ngIf="data.male_data">{{ data.male_data | number: '1.2-2' }}%</div>
										<div *ngIf="!data.male_data">--</div>
									</div>
									<div class="width-33p device-data" [ngClass]="{ 'primary-color': true }">
										<div *ngIf="data.female_data">{{ data.female_data | number: '1.2-2' }}%</div>
										<div *ngIf="!data.female_data">--</div>
									</div>
									<div class="width-33p device-data" [ngClass]="{ 'tertiary-color': true }">
										<div *ngIf="data.unknown_data">{{ data.unknown_data | number: '1.2-2' }}%</div>
										<div *ngIf="!data.unknown_data">--</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
